<template>
	<div class="component">
		<p class="label">
			{{ question.name }}
		</p>
		<div class="count_content">
			<div class="text">{{ formateValue&&formateValue.ret}}</div>
			<van-tag
				v-if="formateValue&&formateValue.tagStyle&&formateValue.tagStyle.text"
				:color="formateValue.tagStyle.color"
				size="medium"
				>{{formateValue.tagStyle.text||value}}</van-tag
			>
		</div>
	</div>
</template>
<script>
export default {
    name: 'GCount',
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        list: {
            type: Array,
            default: () => []
        },
        question: {
            type: Object,
            default: () => { }
        }
    },
    data () {
        return {
        }
    },
    asyncComputed: {
        async formateValue () {
            return await this.change()
        }
    },
    methods: {
        async change () {
            let ret = '--'
            let tagStyle = {
                text: '',
                color: '',
            }
            let arr = JSON.parse(JSON.stringify(this.list))
            const { count, toFixed, tag } = this.question.setting
            if (arr) {
                let strCount = JSON.parse(JSON.stringify(count))
                await arr.map(async v => {
                    let key = new RegExp("(" + v.key + ")", "g")
                    if (strCount.indexOf(v.key) > -1) {
                        strCount = strCount.replace(key, parseFloat(v.value || 0))
                    }
                    await v.optionList && v.optionList.map(async j => {
                        let key2 = new RegExp("(" + j.key + ")", "g")
                        if (strCount.indexOf(j.key) > -1) {
                            strCount = strCount.replace(key2, parseFloat(j.value || 0))
                        }
                    })
                })
                let number = eval(strCount)
                if (typeof number === 'number' && number != Infinity && !isNaN(number)) {
                    ret = parseFloat(number).toFixed(toFixed)
                    tagStyle = tag && tag(ret)
                }
            }
            this.$emit('input', ret === '--' ? '' : ret)
            return new Promise((resolve) => {

                console.log(ret)
                resolve({ ret, tagStyle })
            })

        }
    }
}
</script>
<style lang="less" scoped>
@import './base.less';
.count_content {
	background-color: #ffffff;
	font-size: 30px;
	color: @primary;
	height: 100px;
	display: flex;
	align-items: center;
	padding: 0 32px;
	border-radius: 16px;
	.text {
		margin-right: 32px;
	}
}
</style>